// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"353":"contact","574":"footer","594":"about","597":"projects","859":"experience"}[chunkId] || chunkId) + "." + {"159":"37e8bde7","274":"570ec410","297":"8101ca6a","353":"e4ee13b3","453":"ace21015","574":"2c590def","594":"bc45e26b","597":"82a4a057","859":"bab53790"}[chunkId] + ".chunk.js";
};